var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 28.5899C41.2167 28.5899 40.1667 29.6399 40.1667 30.9233V43.1033C40.1667 44.3866 39.1167 45.4366 37.8333 45.4366H14.5C13.2167 45.4366 12.1667 44.3866 12.1667 43.1033V19.2566C12.1667 17.9733 13.2167 16.9233 14.5 16.9233H26.1667C27.45 16.9233 28.5 15.8733 28.5 14.5899C28.5 13.3066 27.45 12.2566 26.1667 12.2566H12.1667C9.6 12.2566 7.5 14.3566 7.5 16.9233V44.9233C7.5 47.4899 9.6 49.5899 12.1667 49.5899H40.1667C42.7333 49.5899 44.8333 47.4899 44.8333 44.9233V30.9233C44.8333 29.6399 43.7833 28.5899 42.5 28.5899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5465 12.2566H44.8332V7.54326C44.8332 6.28326 43.8065 5.25659 42.5465 5.25659H42.4765C41.1932 5.25659 40.1665 6.28326 40.1665 7.54326V12.2566H35.4765C34.2165 12.2566 33.1898 13.2833 33.1665 14.5433V14.6133C33.1665 15.8966 34.1932 16.9233 35.4765 16.9233H40.1665V21.6133C40.1665 22.8733 41.1932 23.9233 42.4765 23.8999H42.5465C43.8065 23.8999 44.8332 22.8733 44.8332 21.6133V16.9233H49.5465C50.8065 16.9233 51.8332 15.8966 51.8332 14.6366V14.5433C51.8332 13.2833 50.8065 12.2566 49.5465 12.2566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1668 21.5903H19.1668C17.8835 21.5903 16.8335 22.6403 16.8335 23.9237C16.8335 25.207 17.8835 26.257 19.1668 26.257H33.1668C34.4502 26.257 35.5002 25.207 35.5002 23.9237C35.5002 22.6403 34.4502 21.5903 33.1668 21.5903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1668 28.59H19.1668C17.8835 28.59 16.8335 29.64 16.8335 30.9233C16.8335 32.2066 17.8835 33.2566 19.1668 33.2566H33.1668C34.4502 33.2566 35.5002 32.2066 35.5002 30.9233C35.5002 29.64 34.4502 28.59 33.1668 28.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1668 35.59H19.1668C17.8835 35.59 16.8335 36.64 16.8335 37.9233C16.8335 39.2066 17.8835 40.2566 19.1668 40.2566H33.1668C34.4502 40.2566 35.5002 39.2066 35.5002 37.9233C35.5002 36.64 34.4502 35.59 33.1668 35.59Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5 0.589966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc3);
export default __webpack_public_path__ + "static/media/doc3.96203bd71145a795acdb1eb145a80504.svg";
export { ForwardRef as ReactComponent };